module.exports = __webpack_public_path__ + "static/mid3-5c35fa28acca8e8ed8f35c77df9dfc24.png";